import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import AuthService from "../../services/auth.service";
import storageService from "../../services/storage.service";
import useQuery from '../../hooks/useQuery';
import appsettings from '../../configs/appsettings.json';
import { useHistory } from 'react-router-dom';

const LoginBAS = () => {
  const [stepBAS, setStepBAS] = useState(0);
  const history = useHistory();
  const query = useQuery();

  var token = query.get('token');

  useEffect(() => {
    async function checkToken() {
      setStepBAS(0);
      if (token) {
        setStepBAS(1);
        const response: any = await AuthService.loginBAS(token);
        setStepBAS(3);
        if (response.success) {
          storageService.setUserLoggedIn(response.result);

          if (response.result.user === undefined && response.result.id === 0) {
            history.push('/Login');
          } else {
            history.push('/Home');
          }
        } else {
          setStepBAS(2);
          setTimeout(() => {
            window.location.href = appsettings.BAS_URL;
          }, 1500);
        }
      } else {
        setStepBAS(2);
        setTimeout(() => {
          window.location.href = appsettings.BAS_URL;
        }, 1500);
      }
    }
    checkToken();
  }, [history, token]);

  const { t } = useTranslation();

  useEffect(() => {
    let auth = storageService.getAccessToken();
    if (!auth) {

    }
  });

  return <>
    <h2>
      {stepBAS == 0 &&
        t("BAS.LOADING")
      }
      {stepBAS == 1 &&
        t("BAS.CONSULTING")
      }
      {stepBAS == 2 &&
        t("BAS.REDIRECTING")
      }
      {stepBAS == 3 &&
        t("BAS.VALIDATING")
      }
    </h2>
  </>;
};

export default LoginBAS;